import React from "react";

const SubNavbar = () => {
  return (
    <div className="w-full bg-primary">
      <div className="flex flex-wrap items-center justify-center lg:gap-12 md:gap-6 gap-2 py-2 mx-auto">
        <button className="text-black font-semibold">Currency Converter</button>
        <button className="text-white font-semibold">
          Browse all currencies
        </button>
      </div>
    </div>
  );
};

export default SubNavbar;
